/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AttachmentResponseDTO,
  BodyAddTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsPost,
  BodyExecuteTestCaseRunApiTestRunsExecuteTestCaseRunIdPut,
  HTTPValidationError,
  TestCaseRunResponseDTO,
  TestRunCreateDTO,
  TestRunListResponseDTO,
  TestRunResponseDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class TestRuns<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags TestRun
   * @name GetTestRunApiTestRunsGet
   * @summary Get Test Run
   * @request GET:/api/test_runs
   * @response `200` `(TestRunListResponseDTO)[]` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestRunApiTestRunsGet = (
    query: {
      /** Project Ref */
      project_ref: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<TestRunListResponseDTO[], HTTPValidationError>({
      path: `/api/test_runs`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name CreateTestRunApiTestRunsPost
   * @summary Create Test Run
   * @request POST:/api/test_runs
   * @response `200` `TestRunResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  createTestRunApiTestRunsPost = (data: TestRunCreateDTO, params: RequestParams = {}) =>
    this.request<TestRunResponseDTO, HTTPValidationError>({
      path: `/api/test_runs`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name GetTestRunDetailApiTestRunsIdGet
   * @summary Get Test Run Detail
   * @request GET:/api/test_runs/{_id}
   * @response `200` `TestRunResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestRunDetailApiTestRunsIdGet = (id: number, params: RequestParams = {}) =>
    this.request<TestRunResponseDTO, HTTPValidationError>({
      path: `/api/test_runs/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name DeleteTestRunsApiTestRunsIdDelete
   * @summary Delete Test Runs
   * @request DELETE:/api/test_runs/{_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteTestRunsApiTestRunsIdDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_runs/${id}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name GetTestCaseRunsApiTestRunsIdTestCasesGet
   * @summary Get Test Case Runs
   * @request GET:/api/test_runs/{_id}/test_cases
   * @response `200` `(TestCaseRunResponseDTO)[]` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getTestCaseRunsApiTestRunsIdTestCasesGet = (id: number, params: RequestParams = {}) =>
    this.request<TestCaseRunResponseDTO[], HTTPValidationError>({
      path: `/api/test_runs/${id}/test_cases`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name GetCaseTestRunDetailApiTestRunsTestCasesIdGet
   * @summary Get Case Test Run Detail
   * @request GET:/api/test_runs/test_cases/{_id}
   * @response `200` `TestCaseRunResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getCaseTestRunDetailApiTestRunsTestCasesIdGet = (id: number, params: RequestParams = {}) =>
    this.request<TestCaseRunResponseDTO, HTTPValidationError>({
      path: `/api/test_runs/test_cases/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name ExecuteTestCaseRunApiTestRunsExecuteTestCaseRunIdPut
   * @summary Execute Test Case Run
   * @request PUT:/api/test_runs/execute/{test_case_run_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  executeTestCaseRunApiTestRunsExecuteTestCaseRunIdPut = (
    testCaseRunId: number,
    data: BodyExecuteTestCaseRunApiTestRunsExecuteTestCaseRunIdPut,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_runs/execute/${testCaseRunId}`,
      method: "PUT",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name AddTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsPost
   * @summary Add Test Case Run Attachment
   * @request POST:/api/test_runs/test_cases/{_id}/attachments
   * @response `201` `AttachmentResponseDTO` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  addTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsPost = (
    id: number,
    data: BodyAddTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsPost,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponseDTO, HTTPValidationError>({
      path: `/api/test_runs/test_cases/${id}/attachments`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TestRun
   * @name DeleteTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsAttachmentIdDelete
   * @summary Delete Test Case Run Attachment
   * @request DELETE:/api/test_runs/test_cases/{_id}/attachments/{attachment_id}
   * @response `204` `void` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  deleteTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsAttachmentIdDelete = (
    id: number,
    attachmentId: number,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/api/test_runs/test_cases/${id}/attachments/${attachmentId}`,
      method: "DELETE",
      ...params,
    });
}
